import tokens from '../tokens/js/tokens';
// Functions.
// -----------------------------------------------------------------------------
export const getFontSize = (size) => tokens.font.size[size].value;
export const getFontWeight = (weight) => tokens.font.weight[weight].value;
//# sourceMappingURL=typography.utils.js.map